import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./components/layout/layout.module')
      .then((m) => m.LayoutModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./components/auth/auth.module')
      .then((m) => m.AuthModule)
  },
  {
    path: 'unauthorized',
    loadChildren: () => import('./components/unauthorized/unauthorized.module')
      .then((m) => m.UnauthorizedModule)
  },
  {
    path: '**',
    loadChildren: () => import('./components/not-found/not-found-module')
      .then((m) => m.NotFoundModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
